/**
 * คีมเล็บพยัคฆ์ไฟ (tongs-claw): its lock routine (design docs/design/combat/2026-10-11-lock-moves-13.md §2.8, kit audit
 * docs/design/combat/2026-10-13-art-kit-audit.md piece 9; the art keeps its bleed: user Q2, DECISIONS 2026-10-13).
 *
 * Lock move bc-maul 撕 (range 2, two blows: the 0.45 s flurry wind-up — drops low on all fours for a frame, shoulders rolled,
 * fingers hooked, a red heat dither on the back). Ground-and-pound: a short pounce bears the foe down, the caster crouches
 * over it and rakes left, right, then a 4-rake flurry; hooks and rolls the foe over, roars over it on its knee, and a two-claw
 * upward tear throws it back. The foe is DOWN for most of the routine (`downHit`: flinching while lying; the rules treat it
 * like any held beat, only `fall` hands the foe to the knock-down rules, so the mount is `downHit`, not `fall`). Every blow
 * is a bc-maul blow, so every rake puts on its bleed (the move's `applies`). vs bs-rend (its sect's other lock): a standing
 * SLASH. Keys (bc* poses, claw/roar fx, tiger sfx: original synth, no recorded game sample) are the contract for the motion /
 * FX / sound lanes. Data only.
 */
import { registerLongMove } from './registry';

/** 撕 พยัคฆ์กดเหยื่อ — pounce, mount, rake left, right, the flurry, roll it over, roar, the upward tear. */
export const TIGER_PINS_PREY = registerLongMove({
  skillId: 'bc-maul',
  kind: 'lock',
  name: 'พยัคฆ์กดเหยื่อ',
  opener: { type: 'contact', range: 0, tell: 0 },
  len: 5.2,
  catch: 0.45,
  power: 2.5,
  lunge: 1.4,
  beats: [
    { at: 0, pose: 'bcPounce', hits: 0, share: 0, foe: 'knock', dist: 0.6, ai: 3, fx: 'pounceDust', sfx: 'tigerChuff', cam: 'hold' },
    { at: 0.45, pose: 'bcMount', hits: 0, share: 0, foe: 'downHit', sfx: 'growlLow', cam: 'push' },
    { at: 0.95, pose: 'bcRakeL', hits: 1, share: 0.1, foe: 'downHit', ai: 1, fx: 'clawTrail', sfx: 'clawRip' },
    { at: 1.4, pose: 'bcRakeR', hits: 1, share: 0.1, foe: 'downHit', ai: 1, fx: 'clawTrail', sfx: 'clawRip2' },
    { at: 1.85, pose: 'bcRakeFlurry', hits: 4, share: 0.24, foe: 'downHit', ai: 2, fx: 'clawTrail', sfx: 'clawRip4' },
    { at: 2.75, pose: 'bcFlip', hits: 0, share: 0, foe: 'spin', fx: 'bloodFleck', sfx: 'bodyRoll' },
    { at: 3.3, pose: 'bcRoar', hits: 0, share: 0, foe: 'kneel', fx: 'roarRing', sfx: 'tigerRoar', cam: 'push' },
    {
      at: 3.9,
      pose: 'bcRendUp',
      hits: 1,
      share: 0.56,
      foe: 'knock',
      dist: 1.6,
      stop: 0.14,
      fx: 'clawCross',
      sfx: 'clawRipBig',
      cam: 'shake',
    },
    { at: 4.5, pose: 'bcCrouch', hits: 0, share: 0, foe: 'fall' },
    { at: 4.75, pose: 'bcStance', hits: 0, share: 0, foe: 'recover' },
  ],
});
